import { BaseContainerModel } from "../base-container.model";

export class EmailNotificationPDFModel extends BaseContainerModel {
  sender: string;
  recipient: string;
  email_title: string;
  email_body: string;
  file_name: string;
  printable_format_hdr_guid: string;
  print_service_class_name: string;
  cc_list?: string[];
  bcc_list?: string[];
  guids?: string[];
  max_total_attachment_size_bytes?: number;
}
